<template>
    <b-card no-body>
        <AddGroupModal
            :visible="showAddGroupDialogue"
            :company-id="user.company_id"
            :member-id="user.id"
            @okToggle="getmemberships()"
        />
        <div slot="header">{{ $t('groups') }}</div>
        <div style="max-height: 500px; overflow-y: scroll">
            <b-list-group flush>
                <transition-group name="slide">
                    <b-list-group-item
                        v-for="gm in groupmembershipList"
                        :key="gm.group.id"
                        class="hoverable-list-group-item"
                    >
                        <router-link :to="getGroupLink(gm.group)">
                            &nbsp; {{ gm.group.display_name }},
                            {{ getGrouptypeName(gm.group) }}
                        </router-link>

                        <span class="pull-right">
                            <a-popconfirm
                                :title="$t('confirm.delete')"
                                @confirm="deleteMembership(gm)"
                                v-if="editEnabled && isManager && !gm.deleting"
                            >
                                <a-button
                                    type="danger"
                                    class="pull-right"
                                    size="small"
                                    shape="circle"
                                    :title="$t('label.confirm')"
                                >
                                    <i class="fa fa-trash" />
                                </a-button>
                            </a-popconfirm>
                            <i
                                class="fa fa-spinner fa-spin"
                                v-if="gm.deleting"
                            />
                        </span>
                    </b-list-group-item>
                </transition-group>
            </b-list-group>
        </div>

        <b-list-group flush v-if="editEnabled && isManager">
            <!-- Add group button -->
            <b-list-group-item>
                <b-btn
                    block
                    variant="ghost-primary"
                    @click="showAddGroupDialogue = !showAddGroupDialogue"
                >
                    <i class="fa fa-plus" />
                    {{ $t('text.addGroups') }}
                </b-btn>
            </b-list-group-item>
        </b-list-group>
    </b-card>
</template>
<script>
import AddGroupModal from '@/components/controls/AddGroupModal'
import { sortBy, get } from 'lodash'
import { mapGetters } from 'vuex'

export default {
    components: {
        AddGroupModal,
    },
    props: {
        user: {
            required: true,
        },
        editEnabled: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            memberships: this.$resource('groupmembers'),
            grouptypes: this.$resource('grouptypes'),
            showAddGroupDialogue: false,
        }
    },

    created() {
        this.getmemberships()
    },

    methods: {
        getmemberships() {
            let memberships = this.memberships
            memberships.setIncludes('group,group.grouptype')
            memberships.setPerPage(10000)
            memberships.setFilter({
                member_id: this.user.id,
                member_type: 'user',
            })
            memberships.fetch()
        },

        deleteMembership(membership) {
            membership.delete().then(() => {
                this.getmemberships()
            })
        },

        getGrouptypeName(group) {
            return get(group, 'grouptype.name', this.$t('label.none'))
        },

        getGroupLink(group) {
            return (
                '/organization/' +
                this.$route.params.orgId +
                '/groups/' +
                group.id
            )
        },
    },

    computed: {
        ...mapGetters({
            authUser: 'auth/user',
            isManager: 'auth/isManager',
            isGlobalAdmin: 'auth/isManager',
        }),

        groupmembershipList() {
            let groups = this.memberships.models
            // .filter(membership => membership.g != null)
            // .filter(g => g.is_hidden != true)

            groups = groups.filter(membership => membership.group != null)
            // groups = groups.map(g => {
            //     return {
            //         ...g.group,
            //         membership: g,
            //     }
            // })

            return sortBy(groups, [
                'group.display_name',
                'group.grouptype.name',
                'group.is_visible',
            ])
        },
    },
}
</script>
<style scoped>
.hoverable-list-group-item:hover {
    background: #eee;
}
.slide-enter-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: ease-in;
    -webkit-transition-timing-function: ease-in;
    -o-transition-timing-function: ease-in;
    transition-timing-function: ease-in;
}

.slide-leave-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
    max-height: 100px;
    overflow: hidden;
}

.slide-enter,
.slide-leave-to {
    overflow: hidden;
    max-height: 0;
}
</style>
